import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';

import { ProgressMulti, Label, Badge } from 'twyne-new.ui';

import ProgressBar from './ProgressBar';

const propTypes = {
  paths: PropTypes.array,
  total: PropTypes.number,
  getLabel: PropTypes.func,
  active: PropTypes.bool,
  onToggleManage: PropTypes.func,
};

function ProgressHeader({ label, pathId, item }) {
  return <div className="flex justify-between mb-1">
    <Link to={`/path/paths/${pathId}`}>
      <Label className='hover:text-blue-500 hover:dark:text-blue-300 cursor-pointer'>[#{pathId}] {label}</Label>
    </Link>
    <div className='flex gap-2'>
      <Badge color='accent' size='sm' variant='outline'>
        rpu: <NumberFormat value={item.rpu || 0} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$ '} decimalScale={2} fixedDecimalScale={true} />
      </Badge>
      <Badge color='neutral' size='sm' variant='outline'>
        impressions: {item.impressions || 0}
      </Badge>
    </div>
  </div>
}

export default function ProgressExpand({ paths, total, getLabel, onToggleManage }) {
  return <>
    {paths.map((item, idx) => {
      const percentage = (item.weigth / total) * 100
      const id = `progress-${item.id}-${item.path_id}-${idx}`
      const label = getLabel(item.path_id)
      const progressLabel = `${percentage.toFixed(0)}%`

      return <div key={id}>
        <ProgressHeader label={label} pathId={item.path_id} item={item} id={id} />
        <ProgressMulti fadeColor>
          <ProgressBar
            index={idx}
            id={id}
            value={percentage}
            label={progressLabel}
            onClick={() => onToggleManage(idx)}
          />
        </ProgressMulti>
      </div>
    })}
  </>
}

ProgressExpand.propTypes = propTypes
ProgressExpand.defaultProps = {}
